/**
 * 63266ef5 («mute typed») muted the agent's audio on every typed line so a text-only
 * chat stays silent. In a voice session (mic open) that muted the agent for the rest of
 * the call (v451 nb, 18.10 13:50:50). Mute only when the mic is not open.
 */
export function typedLineMutesAgentAudio({ micActive }: { micActive: boolean }): boolean {
  return !micActive
}
